import { middlewares } from '@spp/ui-core-navigation';

export default () => [
    middlewares.coreNavigationUI,
    middlewares.spid,
];



/** WEBPACK FOOTER **
 ** ./src/redux/middlewares.js
 **/